export default __webpack_public_path__ + "static/media/Tangpark-logo.0a05c313.webp";